import React from 'react';

/**
 * ProtocolTag — serialized coach's-clipboard index label.
 *
 * A tiny detail no other athlete site does. Sits above the hero
 * headline like a document classification stamp:
 *
 *   ─── PROTOCOL 001 · GRADE 5-8 UNIFIED ───
 *
 * Props:
 *   number   string  e.g. "001"
 *   label    string  e.g. "GRADE 5-8 UNIFIED"
 *   color    string  hex (defaults to SAA orange)
 */
const ORANGE = '#FF5E00';

const ProtocolTag = ({ number = '001', label, color = ORANGE, className = '' }) => {
  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="protocol-tag"
    >
      <span
        aria-hidden
        className="h-px w-8"
        style={{ background: `linear-gradient(90deg, transparent, ${color}90)` }}
      />
      <span
        className="text-[10px] font-black tracking-[0.32em] uppercase"
        style={{ color }}
      >
        Protocol {number}
      </span>
      {label ? (
        <>
          <span
            aria-hidden
            className="h-1 w-1 rounded-full"
            style={{ backgroundColor: color, opacity: 0.6 }}
          />
          <span className="text-[10px] font-bold tracking-[0.28em] uppercase text-gray-400">
            {label}
          </span>
        </>
      ) : null}
      <span
        aria-hidden
        className="h-px w-8"
        style={{ background: `linear-gradient(90deg, ${color}90, transparent)` }}
      />
    </div>
  );
};

export default ProtocolTag;
